#import "../fragments/broadcast-stub-fragment.graphql"

mutation CreateBroadcast($broadcast: BroadcastCreateInput!) {
    broadcastCreate(input: $broadcast) {
        broadcast {
            ...BroadcastStubFragment
        }
    }
}
